import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const menu = require.context('./menu', false, /\.svg$/)
const nav = require.context('./nav', false, /\.svg$/)
const form = require.context('./form', false, /\.svg$/)
const home = require.context('./home', false, /\.svg$/)

const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
requireAll(menu)
requireAll(nav)
requireAll(form)
requireAll(home)



// WEBPACK FOOTER //
// ./src/icons/index.js